/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Contains basic functionality for manipulation with references within a document.
 * <p>
 * Each schema may work with references in a different way, so an implementation
 * of this interface is provided for each {@link io.apicurio.datamodels.core.models.Document} type.
 * 
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 */
export interface IReferenceManipulationStrategy {
    /**
     * Add the node to the document (wrapped) as a component/definition.
     * <p>
     * Given a node, if it can be represented as a {@link io.apicurio.datamodels.core.models.common.IDefinition},
     * it's wrapped into one and attached to the appropriate place in the document.
     * <p>
     * This new definition node is returned (the original itself is not attached),
     * together with a canonical reference to the new definition.
     * <p>
     * The reference is generated from the provided name. If a definition with the provided name
     * already exists, throw an {@link java.lang.IllegalArgumentException}.
     * 
     * @param {Document} model     Target model to manipulate
     * @param {string} name      Suggested definition name
     * @param {Node} component Node to be attached as a definition
     * @return {IReferenceManipulationStrategy.ReferenceAndNode} new definition node with the new reference to it
     * @throws java.lang.IllegalArgumentException if there is a naming conflict. // TODO some better way?
     */
    attachAsComponent(model : Document, name : string, component : Node) : IReferenceManipulationStrategy.ReferenceAndNode;

    /**
     * Get a collection of local components/definitions, mapped by their local reference string.
     * 
     * @param {Document} model
     * @return {*} A collection of local components/definitions
     */
    getExistingLocalComponents(model : Document) : any;

    /**
     * Get the name of the component.
     * 
     * @param {Document} document
     * @param {Node} component
     * @return {string} null if component with that name was not found.
     */
    getComponentName(document : Document, component : Node) : string;

    /**
     * Remove component with a given name.
     * 
     * @param {Document} document
     * @param {string} name
     * @return {boolean} true if a component with that name was removed
     */
    removeComponent(document : Document, name : string) : boolean;
}

export namespace IReferenceManipulationStrategy {

    /**
     * @param {string} ref  nullable
     * @param {Node} node nullable
     * @class
     */
    export class ReferenceAndNode {
        ref : string;

        node : Node;

        public constructor(ref : string, node : Node) {
            if(this.ref===undefined) this.ref = null;
            if(this.node===undefined) this.node = null;
            this.ref = ref;
            this.node = node;
        }

        public getRef() : string {
            return this.ref;
        }

        public getNode() : Node {
            return this.node;
        }

        /**
         * 
         * @param {*} o
         * @return {boolean}
         */
        public equals(o : any) : boolean {
            if(this === o) return true;
            if(o == null || (<any>this.constructor) !== (<any>o.constructor)) return false;
            let that : IReferenceManipulationStrategy.ReferenceAndNode = <IReferenceManipulationStrategy.ReferenceAndNode>o;
            if(this.ref != null?!/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(this.ref,that.ref)):that.ref != null) return false;
            return this.node != null?/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(this.node,that.node)):that.node == null;
        }

        /**
         * 
         * @return {number}
         */
        public hashCode() : number {
            let result : number = this.ref != null?/* hashCode */(<any>((o: any) => { if(o.hashCode) { return o.hashCode(); } else { return o.toString().split('').reduce((prevHash, currVal) => (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0); }})(this.ref)):0;
            result = 31 * result + (this.node != null?/* hashCode */(<any>((o: any) => { if(o.hashCode) { return o.hashCode(); } else { return o.toString().split('').reduce((prevHash, currVal) => (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0); }})(this.node)):0);
            return result;
        }
    }
    ReferenceAndNode["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.IReferenceManipulationStrategy.ReferenceAndNode";

}



